import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import StringField from './StringField';
import { ColorBoxField } from './ColorBoxField';
import { ReorderButton } from './ReorderButton';
import * as appTheme from '../../../_common/platform/ts/appTheme';
import * as Utilities from '../../../_common/platform/ts/Utilities';
import { IPopupOptions } from '../../../pdc-platform/src/ts/actions/DialogActions';

class PaletteColorRow extends React.Component<any, any> {
    constructor(props) {
        super(props);
    }

    isFictiv() {
        return this.props.i === -1;
    }

    processAddFresh = () => {
        if (typeof this.props.onAddRow === 'function') {
            this.props.onAddRow();
        }
    };

    handleChange = (value) => {
        //  this.props.value = color
        //this.normalize(value);
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    };

    handleColorChange = (val) => {
        let obj = val;
        this.handleChange(obj);
    };

    handleRemove = (e) => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    };

    getRemoveButton = (value) => {
        if (this.isFictiv()) {
            return;
        }

        if (value == null) {
            return;
        } // value is color

        return (
            <span
                className="glyphicon glyphicon-remove"
                style={{ cursor: 'pointer' }}
                onClick={this.handleRemove}
            ></span>
        );
    };

    getColor = (value) => {
        return (
            <ColorBoxField
                value={value}
                themeObj={this.props.themeObj}
                hideTransparency={true}
                showText={true}
                readOnly={false}
                disabled={false}
                onChange={this.handleColorChange}
                glob={this.props.glob}
            />
        );
    };

    render() {
        if (this.isFictiv()) {
            let displayVal = (
                <em className="empty btn btn-default" onClick={this.processAddFresh}>
                    {'Add Color'}
                </em>
            );

            let style1 = {
                marginLeft: '15px',
                marginTop: '8px',
                marginBottom: '5px'
            };

            return (
                <div className="entity-select" style={style1}>
                    <div className="content">
                        <span className="value">{displayVal}</span>
                    </div>
                </div>
            );
        }

        let value = this.props.value;

        //LL: 18.02.20:  reorder-container     nRows={ colors.length }
        let reorderButton = <ReorderButton nItems={this.props.nRows} />;

        return (
            <div className="color-row">
                <div className="reorder-container" style={{ cursor: 'grab' }}>
                    {reorderButton}
                </div>
                <div className="remove-container" style={{ cursor: 'pointer' }}>
                    {this.getRemoveButton(value)}
                </div>
                <div className="value-container">{this.getColor(value)}</div>
            </div>
        );
    }
}

class DefinePaletteColors extends React.Component<
    {
        value;
        themeObj?: appTheme.IValuesCollection;
        onChange(value, colorListApplied, hasError?);
        onColorListChanged();
        glob: IGlob;
    },
    { colorList }
> {
    //LL: 15.01.25
    private references: {
        tableBody?: HTMLElement; // HTMLDivElement;
        copyInput?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);
        this.state = {
            colorList: ''
        };
    }

    private startIndex;

    reorderStart = (e, ui) => {
        this.startIndex = $(ui.item).index();
    };

    reorderStop = (e, ui) => {
        if (this.startIndex == null) {
            return;
        }

        let startIndex = this.startIndex;
        let stopIndex = $(ui.item).index();

        this.startIndex = null;

        //LL: see: https://gist.github.com/avakhov/7b9d2b1a354e59dbfa63
        //   Вызываем cancel, чтобы элементы местами поменял React.js
        //   $(me.getDOMNode()).sortable("cancel");
        let tableBody: any = this.references.tableBody; //LL: 15.01.25
        $(tableBody).sortable('cancel');

        this.processReorder(startIndex, stopIndex);
    };

    componentDidMount() {
        //LL: 18.02.20:  reorder-container
        let tableBody: any = this.references.tableBody; //LL: 15.01.25
        if (typeof $(tableBody).sortable === 'function') {
            $(tableBody).sortable({
                axis: 'y',
                forceHelperSize: true,
                items: '.color-row:not(.empty)',
                opacity: 0.8,
                handle: '.reorder-container', //LL: 18.02.20   // '.remove-container',
                cursor: 'grabbing',
                start: this.reorderStart,
                stop: this.reorderStop
            });
        }
    }

    componentWillUnmount() {
        let tableBody: any = this.references.tableBody; //LL: 15.01.25
        $(tableBody).sortable('destroy');
    }

    processReorder(start, stop) {
        if (start === stop) {
            return;
        }

        let value = this.props.value.slice(0);

        let item = value.splice(start, 1);
        value.splice(stop, 0, item[0]);

        this.processChange(value, false);
    }

    //getDefaultColor = () => {
    //    //return this.props.defaultColor != null ? this.props.defaultColor : "black";
    //    return "black";
    //}

    addRow = () => {
        let obj = this.props.value || [];
        obj = obj.slice(0);

        //let newVal = null;  // or some default color,  black ?
        let newVal = '#000000'; // black
        obj.push(newVal);
        this.processChange(obj, false);
    };

    handleRemoveColor = (i) => {
        let obj = this.props.value || [];
        obj = obj.slice(0);
        obj.splice(i, 1);
        this.processChange(obj, false);
    };

    handleColorChange = (value, i) => {
        // value is color
        let obj = this.props.value || [];
        obj = obj.slice(0);
        obj.splice(i, 1, value);

        //LL: handleChange = (value, colorListApplied, hasError?)
        this.processChange(obj, false);
    };

    //LL: handleChange = (value, colorListApplied, hasError?)
    processChange = (value, colorListApplied, hasError?) => {
        //  value is colors[]
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, colorListApplied, hasError);
        }
    };

    processColorListChange = (val) => {
        this.setState(
            _.extend(this.state, {
                colorList: val
            })
        );

        if (typeof this.props.onColorListChanged === 'function') {
            this.props.onColorListChanged();
        }
    };

    processAddFromList = () => {
        let obj = this.props.value || [];
        obj = obj.slice(0);

        let colorList = this.state.colorList;
        //  space or comma separated list

        //LL: about regexp =======================================
        //LL:  regexp   https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/RegExp
        //    let re = /\s*;\s*/;
        //   метод split() ищет 0 или более пробелов, за которыми следует точка с запятой,
        // за которой снова следуют 0 или более пробелов, и, если этот шаблон найден, удаляет пробелы из строки.
        //
        // let re = / \s*/;   //LL: at least 1 space, other spaces wi;; be also removed
        //
        //LL: check for #  !!  "#\d\d\d\d\d\d"  "#\xhh\xhh\xhh"  [0123456789abcdefABCDEF]
        //    \xhh	Сопоставляется с символом с кодом hh (две шестнадцатеричные цифры).
        //   [xyz]	Набор символов.
        //   Сопоставляется с любым из заключённых в квадратные скобки символов.
        //   С помощью дефиса вы можете определить диапазон символов.
        //    Например, шаблон [абвгд] означает тоже самое, что и шаблон [а-д]

        //    g     глобальное сопоставление
        //    i     игнорирование регистра при сопоставлении

        ////  now space separated =================
        //
        ////let colors = colorList.split(' ');
        ////colors = _.map(colors, function(str: string){ return str.trim(); });
        //
        //let re = / \s*/;   //LL: at least 1 space, other spaces wi;; be also removed
        //let colors = colorList.split(re);
        //
        //let reColor = /#[0123456789abcdefABCDEF][0123456789abcdefABCDEF][0123456789abcdefABCDEF][0123456789abcdefABCDEF][0123456789abcdefABCDEF][0123456789abcdefABCDEF]/;
        //
        //let colorsTrue = [];
        //_.each(colors, function(str: string) {
        //    //  there are search() and match()
        //
        //    //let i = str.search(reColor);
        //    //if (i >= 0) {
        //    //    colorsTrue.push(str.substr(i));
        //    //}
        //
        //    let arr = str.match(reColor);
        //    if (arr != null) {
        //        colorsTrue.push(arr[0]);
        //    }
        //});
        //
        ////Array.prototype.push.apply(obj, colors);
        //Array.prototype.push.apply(obj, colorsTrue);

        //LL: use match()  without split and different separators: ==============
        //    var regexp = /[А-Д]/gi;
        //    Если регулярное выражение содержит флаг g, метод вернёт массив, содержащий все сопоставления.
        //    Если сопоставлений не было, метод вернёт значение null.
        let reColor2 =
            /#[0123456789abcdefABCDEF][0123456789abcdef][0123456789abcdef][0123456789abcdef][0123456789abcdef][0123456789abcdef]/gi;
        let arr2 = colorList.match(reColor2);
        if (arr2 != null) {
            Array.prototype.push.apply(obj, arr2);
        }

        //this.processChange(obj);
        this.processChange(obj, true);
    };

    processCopyToList = () => {
        let value = this.props.value || []; // value = colors
        let colors = value;

        let len = colors.length;
        let colorsStr = '';
        _.each(colors, (color, i) => {
            colorsStr += color + (i + 1 < len ? ' ' : '');
        });
        //console.log("processCopyToList colorsStr = " + colorsStr);

        //LL: into separate field:
        let copyInputElem: any = this.references.copyInput; //LL: 15.01.25
        copyInputElem.value = colorsStr;
        //copyInputElem.defaultValue = colorsStr;  // no
    };

    render() {
        let value = this.props.value || []; // value = colors

        //let colors = ["#AFB42B", "#FF9100", "#00ACC1", "#1B5E20", "#FF5722"];  // temp
        let colors = value;

        //LL: 18.02.20: nRows={ colors.length }
        //LL: 07.11.19  popupPriority

        let colorsElem = _.map(colors, (color, i) => {
            return (
                <PaletteColorRow
                    key={i}
                    value={color}
                    i={i}
                    nRows={colors.length}
                    onAddRow={this.addRow}
                    onChange={this.handleColorChange}
                    onRemove={this.handleRemoveColor}
                    themeObj={this.props.themeObj}
                    glob={this.props.glob}
                />
            );
        });

        let addRowElem = (
            <PaletteColorRow
                key={-1}
                i={-1}
                themeObj={this.props.themeObj}
                onAddRow={this.addRow}
                glob={this.props.glob}
            />
        );

        let useColorList = true; //LL: my flag

        let addFromColorListElem;
        if (useColorList) {
            let style1 = {
                marginLeft: '15px',
                marginTop: '8px',
                marginBottom: '5px'
            };

            let addFromListButton = (
                <div className="entity-select" style={style1}>
                    <div className="content">
                        <span className="value">
                            <em className="empty btn btn-default" onClick={this.processAddFromList}>
                                Add Colors from list
                            </em>
                        </span>
                    </div>
                </div>
            );

            let copyToListButton = (
                <div className="entity-select" style={style1}>
                    <div className="content">
                        <span className="value">
                            <em className="empty btn btn-default" onClick={this.processCopyToList}>
                                {'Copy Colors to string'}
                            </em>
                        </span>
                    </div>
                </div>
            );
            //LL: Copy Colors here, to separate field:
            let copyInputElem = (
                <input
                    ref={(input) => {
                        this.references.copyInput = input;
                    }} //LL: 15.01.25
                    className="form-control"
                    value={''}
                    onChange={null}
                    readOnly={true}
                />
            );

            let colorList = this.state.colorList;
            let colorListElem = (
                <StringField
                    value={colorList}
                    readOnly={false}
                    allowNull={false}
                    applyOnEnter={true}
                    changeOnBlurOnly={true}
                    onChange={this.processColorListChange}
                />
            );

            let style2 = {
                marginTop: '8px',
                borderTop: 'solid 1px #cccccc',
                paddingTop: '12px'
            };

            addFromColorListElem = (
                <div style={style2}>
                    <label>{'Space or Comma separated Color list (#rrggbb):'}</label>
                    {colorListElem}
                    {addFromListButton}
                    {copyInputElem}
                    {copyToListButton}
                </div>
            );
        }

        return (
            <div
                className="define-palette-colors-component"
                ref={(input) => {
                    this.references.tableBody = input;
                }} //LL: 15.01.25
            >
                {colorsElem}
                {addRowElem}
                {addFromColorListElem}
            </div>
        );
    }
}

interface IColorsSelectPopupOptions extends IPopupOptions {
    value; // value is colors[]
    themeObj?: appTheme.IValuesCollection;
    onChange(value): void;
}

class ColorsSelectPopup extends React.Component<
    {
        zIndex: number;
        options: IColorsSelectPopupOptions;
        close(): void;
        glob: IGlob;
    },
    {
        value;
        hasError;
        colorListChanged;
        height?: number;
        width?: number;
    }
> {
    private references: {
        popoverContent?: HTMLElement; // HTMLDivElement; // 'popover-content'
    } = {};

    constructor(props) {
        super(props);

        // value is array colors[]
        this.state = {
            value: this.props.options.value, // value is colors[]
            hasError: false,
            colorListChanged: false,
            height: 500, //LL: as in FormatChooser  ??? can change, depends on current Tab  Reset in DidMount
            width: 530 //LL: as in FormatChooser   sass - 520      Reset in DidMount
        };
    }

    componentDidMount() {
        const dialog = this.references.popoverContent;
        // VR: needed for JEST testing: "if(dialog != null)"
        if (dialog != null) {
            this.setState(
                _.extend(this.state, {
                    height: dialog.clientHeight,
                    width: dialog.clientWidth
                })
            );
        }
    }

    handleChange = (value, colorListApplied, hasError?) => {
        //  value is colors[]
        //this.normalize(value);

        let colorListChanged = this.state.colorListChanged;
        if (colorListApplied === true) {
            colorListChanged = false;
        }

        this.setState({
            value: value,
            colorListChanged: colorListChanged,
            hasError: hasError
        });
    };

    closeButtonHandler = () => {
        if (this.state.colorListChanged === true) {
            let result = confirm('Color List was changed, but not applied. Proceed ?');
            if (result === false) {
                return;
            }
        }

        let hasError = this.state.hasError;

        if (hasError === true) {
            //this.props.options.glob.AppActions.showNotification_Warning('Configuration is not valid. Some fields have wrong value');
        } else {
            if (typeof this.props.options.onChange === 'function') {
                this.props.options.onChange(this.state.value);
            }
            this.props.close();
        }
    };

    escapeButtonHandler = () => {
        this.props.close();
    };

    handleColorListChanged = () => {
        this.setState({
            colorListChanged: true
        });
    };

    getDefinePaletteColors = () => {
        return (
            <DefinePaletteColors
                value={this.state.value || []}
                themeObj={this.props.options.themeObj}
                glob={this.props.glob}
                onChange={this.handleChange}
                onColorListChanged={this.handleColorListChanged}
            />
        );
    };

    render() {
        const popoverStyle = Utilities.getPopoverStyle(this.props.options, {
            width: this.state.width,
            height: this.state.height
        });

        let style = {
            display: 'block',
            left: popoverStyle.left,
            top: popoverStyle.top,
            zIndex: this.props.zIndex
        };

        let popupTitle = 'Palette Colors';

        let styleDefineColors: any = {}; // { borderTop: "1px solid gray" };

        let defineColorsContent = this.getDefinePaletteColors();

        let mainContentElem = (
            <div className="popover-body">
                <div style={styleDefineColors}>{defineColorsContent}</div>
            </div>
        );

        let errors = []; // = validateWhole(this.state.value, this.props.options.type);
        let styleError: any = { color: 'red', margin: '10px' };
        let errorsElem = <div style={styleError}>{errors.join(', ')}</div>;

        let hasError = this.state.hasError;
        if (errors.length > 0) {
            hasError = true;
        }

        let okButtonClass = 'btn btn-success';
        if (hasError === true) {
            okButtonClass += ' disabled';
        }

        return (
            <div className="palette-colors">
                <div
                    className={'popover palette-colors-popover ' + popoverStyle.side}
                    style={style}
                    ref={(input) => {
                        this.references.popoverContent = input;
                    }}
                >
                    <div className="arrow" style={{ top: popoverStyle.arrowTop }}></div>

                    <h3 className="popover-header">
                        {popupTitle}
                        <button
                            type="button"
                            className="close"
                            title="Cancel all changes"
                            onClick={this.escapeButtonHandler}
                        >
                            ×
                        </button>
                    </h3>

                    {errorsElem}

                    {mainContentElem}

                    <div className="modal-footer">
                        <button className={okButtonClass} onClick={this.closeButtonHandler}>
                            {'OK'}
                        </button>
                        <button className="btn btn-default" onClick={this.escapeButtonHandler}>
                            {'Cancel'}
                        </button>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </div>
        );
    }
}

//LL: see in DiscreteIntervals.tsx
class Color_RenderComponentResult extends React.Component<any, any> {
    render() {
        let color = this.props.label;

        if (color != null) {
            let styleColor: React.CSSProperties = {
                backgroundColor: color
            };

            return <div className="color" style={styleColor} title={this.props.title}></div>;
        } else {
            return (
                <p className="text" title={this.props.title}>
                    not_set
                </p>
            );
        }
    }
}

export class PaletteColors extends React.Component<
    {
        value;
        readOnly?: boolean; //LL: 13.12.19: for PaletteListField.tsx  readOnly -> without "cog" glyph
        themeObj;
        onChange(value): void;
        glob: IGlob;
    },
    {
        popup?: boolean; //LL: 28.11.22: PPP
        isInSettingsView?: boolean; //LL: 28.11.22: PPP
        isInModalDialog?: boolean; //LL: 28.11.22: PPP
    }
> {
    //LL: 28.11.22 PPP
    private references: {
        container?: HTMLDivElement; // ".palette_colors_custom"
    } = {};

    constructor(props) {
        super(props);

        //LL: 28.11.22 PPP
        this.state = { popup: false };
    }

    //LL: 28.11.22 PPP
    componentDidMount() {
        //LL: it is better, above sometimes is wrong
        let d2 = $(this.references.container).parents('.settings-view');
        let isInSettingsView2 = d2 != null && d2.length > 0;

        let f2 = $(this.references.container).parents('.modal-dialog');
        let isInModalDialog2 = f2 != null && f2.length > 0;

        this.setState({ isInSettingsView: isInSettingsView2, isInModalDialog: isInModalDialog2 });
    }

    componentWillUnmount() {}

    handleChange = (value) => {
        // value is colors[]
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value); //LL: to caller
        }
    };

    //LL: 28.11.22 PPP
    handleClose = () => {
        this.setState({ popup: false });
    };

    handleColorsDialogShow = (e) => {
        const offset = $(e.target).offset();

        //LL: 28.11.22 PPP
        //LL: problem is in e.stopPropagation();
        //  When from Config (from a Dialog), stopPropagation must NOT BE
        //  When from Administration/Settings/Options, stopPropagation must BE
        //  When from Administration/Themes, stopPropagation must NOT BE

        //LL: 28.11.22: PPP
        let popup = this.state.popup;
        let isInSettingsView = this.state.isInSettingsView;
        if (isInSettingsView === true && popup === true) {
            e.preventDefault();
            //return;
        }

        //LL: 28.11.22: PPP
        //LL: see DiscreteIntervals.tsx
        const useFadeShow = true;
        e.preventDefault();
        // see this.setState({isInSettingsView: isInSettingsView, isInModalDialog: isInModalDialog});
        if (this.state.isInSettingsView === true && useFadeShow) {
            //if (this.state.isInSettingsView === true) {
            //if (this.state.isInSettingsView === true && popup !== true) {
            e.stopPropagation();
        }

        this.props.glob.DialogActions.createPopup<IColorsSelectPopupOptions>('custom', {
            top: offset.top,
            left: offset.left,
            value: this.props.value, // value is colors[]
            themeObj: this.props.themeObj,
            onChange: this.handleChange,
            close: this.handleClose, //LL: 28.11.22 PPP
            component: ColorsSelectPopup
        });

        this.setState({ popup: true }); //LL: 28.11.22 PPP
    };

    render() {
        let labels; //LL: labels are "colors", "icons", "dates", etc

        if (this.props.value == null || this.props.value == null) {
            labels = <em className="empty" onClick={this.handleColorsDialogShow}></em>;
        } else {
            // this.props.value is colors[]

            let N = this.props.value.length;

            labels = _.map(this.props.value, (color: any, i) => {
                let title = color;

                //LL: see DiscreteIntervals.tsx  <kindDescrObj.renderComponentResult
                return (
                    <Color_RenderComponentResult
                        key={i}
                        label={color}
                        title={title}
                        isLast={i === N - 1}
                        glob={this.props.glob}
                    />
                );
            });
        }

        //LL: 13.12.19: for PaletteListField.tsx  readOnly -> without "cog" glyph
        let readOnly = this.props.readOnly != null ? this.props.readOnly : false;
        let cog = null;
        if (!readOnly) {
            cog = (
                <span className="icon-container glyphicon glyphicon-cog" onClick={this.handleColorsDialogShow}></span>
            );
        }

        return (
            <div
                className="palette_colors_custom"
                ref={(input) => {
                    this.references.container = input;
                }}
            >
                <div className="content">
                    {cog}
                    <span className="form-control values-container">{labels}</span>
                </div>
            </div>
        );
    }
}

// ================ PalettesField ===================

class PalettesFieldRow extends React.Component<any, any> {
    constructor(props) {
        super(props);
        //  themeObj={ self.props.themeObj }  sent
    }

    normalize(value) {
        if (value.name == null) {
            delete value.colors;
            return;
        }

        //LL: wrong
        //if (value.value != null) {
        //    value.value = $.trim(value.value);
        //}
    }

    processNameChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.name = val;
        this.handleValueChange(obj);
    };
    processNameClick = (e) => {
        let obj = _.clone(this.props.value || {});
        obj.name = '';
        this.handleValueChange(obj);
    };

    handleValueChange(value) {
        this.normalize(value);

        delete value.inherited; //LL:  changed => not inherited

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    }

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    };

    getRemoveButton(value) {
        if (value.name == null) {
            return;
        }

        //LL: "disabled" not used ?
        if (value.disabled === true) {
            return;
        }

        if (value.inherited === true) {
            return <span className="glyphicon glyphicon-arrow-down"></span>;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    }

    getNameTitle(value) {
        return value.name || '';
    }

    getName(value) {
        let displayVal = value.name || '';

        if (value.name == null) {
            let displayValEmpty = (
                <button type="button" className="btn btn-default btn-sm" onClick={this.processNameClick}>
                    {'Add Palette'}
                </button>
            );
            return (
                <div className="entity-select">
                    <div className="content">
                        <span className="value">{displayValEmpty}</span>
                    </div>
                </div>
            );
        }

        let readOnly = value.disabled === true;

        return (
            <StringField
                value={displayVal}
                readOnly={readOnly}
                allowNull={false}
                applyOnEnter={true}
                changeOnBlurOnly={true}
                onChange={this.processNameChange}
            />
        );
    }

    process_Colors_Change = (val) => {
        // val is colors[]
        const obj = _.clone(this.props.value || {});

        obj.colors = val;
        this.handleValueChange(obj);
    };

    getColors(value) {
        if (value.name == null) {
            return;
        }

        let colors = value.colors; //  may be null

        return (
            <PaletteColors
                value={colors}
                themeObj={this.props.themeObj}
                glob={this.props.glob}
                onChange={this.process_Colors_Change}
            />
        );
    }

    render() {
        let value = this.props.value || {};
        let style1: any = {};

        if (value.disabled === true) {
            style1.backgroundColor = '#eeeeee';
            style1.cursor = 'default';
        }

        return (
            <tr style={style1}>
                <td className="cell-remove">{this.getRemoveButton(value)}</td>
                <td className="cell-name" title={this.getNameTitle(value)}>
                    {this.getName(value)}
                </td>
                <td className="cell-colors">{this.getColors(value)}</td>
            </tr>
        );
    }
}

export default class PalettesField extends React.Component<
    {
        value?;
        border?: boolean;
        themeObj: appTheme.IValuesCollection;
        glob: IGlob;
        onChange(value): void;
    },
    {}
> {
    private references: {
        tableBody?: HTMLElement;
    } = {};

    constructor(props) {
        super(props);
    }

    //LL: 18.02.20:  NOTE about Reorder vs Sorting: =============================
    //   Items can either reordered by user's DragDrop or sorted by some internal algorithm (alphabetically here)
    //   Previous solution was Reorder, but it is not convenient and mixing own/parent items is bad
    //   So, now it will be Sorting, see function getSortedValuesByName
    //============================================================================

    handleValueChange(value) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    addRow = (obj) => {
        let arr = this.props.value.slice(0);

        obj.colors = null; // or [] ?
        obj.disabled = false;

        arr.push(obj);
        this.handleValueChange(arr);
    };

    changeRow = (obj, i) => {
        let arr = this.props.value.slice(0);
        let prev = arr.splice(i, 1, obj)[0];
        this.handleValueChange(arr);
    };

    removeRow = (i) => {
        let arr = this.props.value.slice(0);
        arr.splice(i, 1);
        this.handleValueChange(arr);
    };

    //LL: 17.02.20: try with indices
    //getSortedValuesByName(values) {
    //    //LL:   array of objects with "name" field
    //    let arr = values.slice(0);
    //    arr.sort(function (a: any, b: any) {
    //        let a1 = a.name.toLowerCase();
    //        let b1 = b.name.toLowerCase();
    //        if (a1 > b1) {
    //            return 1;
    //        }
    //        if (a1 < b1) {
    //            return -1;
    //        }
    //        return 0; // a = b
    //    });
    //
    //    let indices = _.map(
    //        arr,
    //        function (obj: any, i) {
    //            let j = _.indexOf(values, obj);
    //            return j;
    //        }
    //    );
    //
    //    return { arr: arr, indices: indices };
    //}

    //LL: 17.02.20: to appTheme
    //LL: 16.02.20: try
    //getSortedValuesByName(values) {
    //    //LL:   array of objects with "name" field
    //    let arr = values.slice(0);
    //    arr.sort(function (a: any, b: any) {
    //        let a1 = a.name.toLowerCase();
    //        let b1 = b.name.toLowerCase();
    //        if (a1 > b1) {
    //            return 1;
    //        }
    //        if (a1 < b1) {
    //            return -1;
    //        }
    //        return 0; // a = b
    //    });
    //    return arr;
    //}

    //LL: 16.02.20: try  NO
    //getSortedValuesByName_tricky(values, ownValues, parentValues) {
    //    //LL:   array of objects with "name" field
    //    let arr = values.slice(0);
    //    let arr2 = _.map(
    //        arr,
    //        (obj: any) => {
    //            let obj2: any = appTheme.setProperInheritedFlag(obj, ownValues, parentValues, "PalettesField");
    //            //LL: can return null when colors are update (reordered)
    //            return obj2;
    //        });
    //
    //    arr2.sort(function (a: any, b: any) {
    //        //let a1 = a.name.toLowerCase();
    //        //let b1 = b.name.toLowerCase();
    //
    //        let a1 = (a != null && a.name != null ? a.name : "");
    //        let b1 = (b != null && b.name != null ? b.name : "");
    //        a1 = a1.toLowerCase();
    //        b1 = b1.toLowerCase();
    //
    //        if (a1 > b1) {
    //            return 1;
    //        }
    //        if (a1 < b1) {
    //            return -1;
    //        }
    //        return 0; // a = b
    //    });
    //
    //    return arr2;
    //}

    render() {
        //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:
        //LL: 23.10.19:
        let objThemeOwnAndParent = appTheme.getThemeOwnAndParentvalues(this.props);
        let ownValues = objThemeOwnAndParent.ownValues;
        let parentValues = objThemeOwnAndParent.parentValues;
        //LL: 16.02.20: no sense:
        //let ownValues = this.getSortedValuesByName(objThemeOwnAndParent.ownValues);
        //let parentValues = this.getSortedValuesByName(objThemeOwnAndParent.parentValues);

        //let aaa = this.getSortedValuesByName(this.props.value);  //LL: 17.02.20 return { arr: arr, indices: indices };
        let aaa = appTheme.getSortedValuesByName(this.props.value); //LL: 17.02.20 return { arr: arr, indices: indices };

        //LL: 26.06.19: add 'number', instead of i, r
        let rows = _.map(
            aaa.arr, //LL: 17.02.20
            (obj: any, i) => {
                let obj2 = appTheme.setProperInheritedFlag(obj, ownValues, parentValues, 'PalettesField');
                //LL: may be null, if just removed
                if (obj2 == null) {
                    return null;
                }

                let j = aaa.indices[i]; //LL: 17.02.20

                //LL: 26.12.19:  can return null when colors are update (reordered)
                let keyR = '';

                if (obj2 != null && obj2.name != null) {
                    keyR = obj2.name;
                }

                return (
                    <PalettesFieldRow
                        key={i + '-' + keyR}
                        i={j}
                        value={obj2}
                        themeObj={this.props.themeObj}
                        onChange={this.changeRow}
                        onRemove={this.removeRow}
                        glob={this.props.glob}
                    />
                );
            }
        );

        let showTableHeaders = rows.length > 0;

        let style1 = { marginBottom: 5 }; // class "table" has margin-bottom:20px

        let style2 = {
            paddingBottom: 15
        };

        return (
            <div className={'palettes-field'}>
                <div className={'div-container'} style={style2}>
                    <div className="palettes-field-common"></div>
                    <table className={'table' + (this.props.border === true ? ' table-bordered' : '')} style={style1}>
                        {showTableHeaders === true ? (
                            <thead>
                                <tr>
                                    <th className="cell-remove"></th>
                                    <th className="cell-name">{'Name'}</th>
                                    <th className="cell-colors">{'Colors'}</th>
                                </tr>
                            </thead>
                        ) : null}
                        <tbody
                            ref={(input) => {
                                this.references.tableBody = input;
                            }}
                        >
                            {rows}
                            <PalettesFieldRow
                                themeObj={this.props.themeObj}
                                onChange={this.addRow}
                                glob={this.props.glob}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
